unable to read source [project]/packages/src/components/base/media/icon/IconTheme.tsx